var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge"},[_c('el-popover',{staticClass:"badge-popover",attrs:{"popper-class":"popperClass","content":_vm.text,"placement":"top","width":"150","trigger":"hover"}},[_c('div',{staticClass:"badge-big",style:({'background-image': 'url('+_vm.selectIcon+')'}),attrs:{"slot":"reference"},on:{"click":_vm.mark},slot:"reference"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d1e6777","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AngleMark.vue
// module id = null
// module chunks = 